import * as ActionType from '../../constants/actionType';

export const setColorPalette = (data) => ({type: ActionType.SET_COLOR_PALETTE, data});

export default setColorPalette;
